import React from 'react'
import TasksCounter from './TasksCounter'

class ListViewItem extends React.Component {
    taskCount() {
      return this.props.data.timeline_items.length;
    }

    allTasksAdded() {
      const { timeline_items } = this.props.data;
      if (timeline_items) {
        const data = $.map(timeline_items, item => item.added_to_leave_plan);
        if (($.inArray(false, data) === -1) && this.props.data.added_to_leave_plan) {
          return '';
        } else {
          return 'all-not-added';
        }
      }
    }

    handleClick(e){
      e.preventDefault();
      $.getJSON(`/${this.props.item_link}/${this.props.data.id}/fetch_details`, data => {
        if (data.statutory_substitutions_options) {
          gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
        }
        return this.props.handleOnClick(this.props.data, data.description);
      });
    }


    render() {
      const divStyle = {backgroundImage: `url(${this.props.data.image_url})`};
      return (
        <div className='col-sm-11 planning-guide-item tasks-counter' onClick={this.handleClick.bind(this)}>
          <div className='plan-guide-img' style={divStyle}> </div>
          <div className='plan-guide-content'>
            <div className={`guide-title ${this.allTasksAdded()}`}>
              <div className='item-name'>
                <h3 className="">
                  {this.props.data.title}
                  {this.taskCount() > 0 && <TasksCounter tasksCount={this.taskCount()}/>}
                </h3>
              </div>
              {this.props.data.theme_name &&
                <div className='theme-name pull-right'>
                  {this.props.data.theme_name}
                </div>
              }
            </div>
            <p className='summary' dangerouslySetInnerHTML={{__html: this.props.data.summary}} />
            <div className='read-more'>
              <a className='standard-link' href='' onClick={this.handleClick.bind(this)}>
                READ MORE
              </a>
            </div>
          </div>
        </div>
      );
    }
}

export default ListViewItem
